// Invitation and password-reset codes are 7 characters, shown as XXX-XXXX
// (backend: utils/invitations.py, format_code). The field formats as the person
// types or pastes: capitals, letters and digits only, the dash after the third
// character, and nothing past the seventh. The backend ignores case and the dash.
// Don't add a maxLength to the input as well: the browser would cut a pasted
// " k7p 4qxa " (spaces included) before this sees it, losing the last character.
const CODE_LENGTH = 7;
const DASH_AFTER = 3;

export function formatInvitationCode(raw) {
  const chars = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, CODE_LENGTH);
  return chars.length > DASH_AFTER ? `${chars.slice(0, DASH_AFTER)}-${chars.slice(DASH_AFTER)}` : chars;
}
